import React from 'react';
import './StorageWarning.css';

/**
 * Component to display when storage is not available
 */
function StorageWarning() {
  return (
    <div className="storage-warning">
      <div className="storage-warning-content">
        <h1>Storage Not Available</h1>
        
        <div className="warning-icon">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 24 24" 
            width="64" 
            height="64" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
        
        <p className="warning-message">
          This application requires browser storage (IndexedDB) to function.
          Please ensure that:
        </p>
        
        <ul className="warning-list">
          <li>You are using a modern browser with IndexedDB support</li>
          <li>You have not blocked storage access for this site</li>
          <li>You are not in private browsing mode (incognito)</li>
          <li>You have sufficient storage space available</li>
        </ul>
        
        <div className="browser-support">
          <h3>Supported Browsers:</h3>
          <div className="browser-icons">
            <div className="browser-icon">
              <span className="icon">Chrome</span>
              <span className="version">Latest</span>
            </div>
            <div className="browser-icon">
              <span className="icon">Firefox</span>
              <span className="version">Latest</span>
            </div>
            <div className="browser-icon">
              <span className="icon">Edge</span>
              <span className="version">Latest</span>
            </div>
            <div className="browser-icon">
              <span className="icon">Safari</span>
              <span className="version">14+</span>
            </div>
          </div>
        </div>
        
        <div className="warning-actions">
          <button 
            className="reload-button"
            onClick={() => window.location.reload()}
          >
            Reload Application
          </button>
        </div>
      </div>
    </div>
  );
}

export default StorageWarning;
